import * as React from "react";
import DeviceContext from "./../../../service/indentifyDevice";
import OpLayout from "../opLayout/opLayout";
import OpQuotesEquityDsk from "../opQuotes/opQuotesEquity/opQuotesEquityDsk";
import OpQuotesEquityTab from "../opQuotes/opQuotesEquity/opQuotesEquityTab";
import OpQuotesEquityMob from "../opQuotes/opQuotesEquity/opQuotesEquityMob";
import { AGetQuotesNormal } from "./../../../service/orderPlacement/opApiService";
import { RouteChildrenProps } from "react-router-dom";
import { IOpRouteParams } from "../../../types/components/orderPlacement/opTypes";

export interface IOpOptionContainerProps {}

export interface IOpOptionContainerState {
	quoteData: any;
}

class OpOptionContainer extends React.Component<IOpOptionContainerProps & RouteChildrenProps<IOpRouteParams>, IOpOptionContainerState> {
	state = { quoteData: {} };
	quoteComp: any;

	getQuotesRes = (res: any) => {
		if (res.data) {
			this.setState({ quoteData: res.data });
		}
	};

	componentDidMount() {
		AGetQuotesNormal(this.getQuotesRes, this.props.match?.params.sym!);
	}

	render() {
		this.quoteComp = DeviceContext().isDesktop ? (
			<OpQuotesEquityDsk quoteData={this.state.quoteData} />
		) : DeviceContext().isTablet ? (
			<OpQuotesEquityTab quoteData={this.state.quoteData} />
		) : (
			<OpQuotesEquityMob quoteData={this.state.quoteData} />
		);
		return <OpLayout quoteComp={this.quoteComp} />;
	}
}

export default OpOptionContainer;
